import React from 'react';
import { Input, Space } from 'antd';
import styles from '../../../event-timeline.module.css';

interface CollisionParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const CollisionParams: React.FC<CollisionParamsProps> = ({
  params,
  setParams,
}) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span className={styles.label}>Object ID:</span>
        <Input
          value={params.objectId}
          onChange={(e) => setParams({ ...params, objectId: e.target.value })}
          placeholder='Enter object ID'
        />
        <span className={styles.label}>Target ID:</span>
        <Input
          value={params.targetId}
          onChange={(e) => setParams({ ...params, targetId: e.target.value })}
          placeholder='Enter target ID'
        />
      </Space>
    </div>
  );
};

export default CollisionParams;
